import * as React from 'react';
const SvgAngleRight = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "m8.926 2.426 8.13 8.637a1.362 1.362 0 0 1 0 1.875l-8.13 8.638a1.366 1.366 0 0 1-1.982-1.878l7.296-7.7L6.944 4.3a1.36 1.36 0 0 1 .054-1.926 1.365 1.365 0 0 1 1.928.053Z", fill: "currentColor" })));
export default SvgAngleRight;
